import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from "@mui/material";
import React, { ReactNode } from "react";

interface Props {
  checked?: boolean;
  label?: ReactNode | string;
  name?: string;
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  errorMessage?: string | false;
}

export default function CustomCheckbox(props: Props) {
  const { label, checked, handleChange, name, error, errorMessage } = props;
  return (
    <FormGroup>
      <FormControlLabel
        sx={{
          "&.MuiFormControlLabel-root": {
            margin: "0px !IMPORTANT",
            alignItems: "start",
          },
        }}
        control={
          <Checkbox checked={checked} onChange={handleChange} name={name} />
        }
        label={label}
      />
      {error && (
        <FormHelperText
          style={{
            padding: "0px",
            margin: "0px",
            color: "red",
            direction: "rtl",
            textAlign: "right",
            fontSize: 13,
          }}
        >
          {errorMessage}
        </FormHelperText>
      )}
    </FormGroup>
  );
}
